import { render, staticRenderFns } from "./TypesMostUsedPieChart.vue?vue&type=template&id=15dde67f&scoped=true&"
import script from "./TypesMostUsedPieChart.vue?vue&type=script&lang=js&"
export * from "./TypesMostUsedPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dde67f",
  null
  
)

export default component.exports